<template>
  <div class="noAuth">
    <h1>无权限</h1>
  </div>
</template>
<script setup lang="ts"></script>
<style scoped></style>
